type RefuseTag = {
  imgLink: string
  imgTag: string[]
}
type RefuseMock = {
  [key: string]: RefuseTag[]
}
export const refuseMock: RefuseMock = {
  '☺': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/f329569336_SnAT9c44l9.png',
      imgTag: ['❤', '🎁'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/75ac4691d0_MU1yg86sUb.gif',
      imgTag: ['😀'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/fa3881f2fb_DG0xbRxonx.png',
      imgTag: ['🧎'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/408556a583_df0lnCxkuV.png',
      imgTag: ['👀'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/718ad4e65d_F6ZBCXjzYW.png',
      imgTag: ['✨'],
    },
  ],
  '💆': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/99d58b8394_ISCmQPRHVO.gif',
      imgTag: ['☕', '🍵'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/64dd246ebf_mLKiledvEb.png',
      imgTag: ['☺'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/1aa7fe1efe_LgkMOX2U7c.gif',
      imgTag: ['😪'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/276c999a7d_58CBVHzRAC.png',
      imgTag: ['🎵'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/bed1a86c58_lw321zgI2z.gif',
      imgTag: ['🤗'],
    },
  ],
  '😞': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/82b4f5d530_Do1DF99Jp1.gif',
      imgTag: ['😰'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/48e08c1ee0_wC1hvWF6Wt.png',
      imgTag: ['😤'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/d04c9fe209_NtPRyNlvlS.png',
      imgTag: ['😢'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/8a5aeb9969_VZstKlGX3N.png',
      imgTag: ['😢', '🐱'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/51a9c163da_SCVldSxLhN.png',
      imgTag: ['😒', '😡'],
    },
  ],
  '😆': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/d6748054db_6G8kI0BdCD.gif',
      imgTag: ['👍'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/8939b9857f_gapETsToAz.png',
      imgTag: ['🤣', '🐰'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/5942a5da38_b1ujzSDPqK.png',
      imgTag: ['☕'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/f3b07fe344_611RNxEIRW.gif',
      imgTag: ['🤣'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/083c3ef5a1_WiItciPEcn.gif',
      imgTag: ['🚿'],
    },
  ],
  '🙇': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/90195f6ea9_ebIOz7xKlU.gif',
      imgTag: ['🍎'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/061f41b16e_74dd2eopl0.png',
      imgTag: ['😢'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/d22fe0c762_zS4W1C48Rw.png',
      imgTag: ['🧎'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/e6534b9814_9QniIZoNY5.png',
      imgTag: ['🤗'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/30b8ad38d3_H7DZpyD7Ud.png',
      imgTag: ['😅'],
    },
  ],
  '😐': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/4d40f9622a_yVZKXjLBKH.png',
      imgTag: ['😅'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/35eceebb3d_gSGxmrN8OE.gif',
      imgTag: ['😀'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/11e3b2b60e_vdBshgW6ih.png',
      imgTag: ['😰'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/737f9b8e47_Di0FipRgZ1.png',
      imgTag: ['😒'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/e254656318_4aF4yEm9LK.gif',
      imgTag: ['💆'],
    },
  ],
  '😡': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/62cf30444f_DEzjnT8J1a.png',
      imgTag: ['❌'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/1c23dd512c_8qBGALuxVH.png',
      imgTag: ['⏱'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/6c0816ebdc_cFsQmrTGY2.gif',
      imgTag: ['😒'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/c654f1f550_7EgG3xdlSf.png',
      imgTag: ['😤'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/f399c67f62_7Uf6nhaJmc.png',
      imgTag: ['😤'],
    },
  ],
  '😊': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/e0467f4706_cgtSIcJ97Z.png',
      imgTag: ['😆'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/f84deec824_B5tywbyrS6.png',
      imgTag: ['🐱'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/ca05f0c048_ZpRjjPnEzy.png',
      imgTag: ['🍀'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/7371df810c_7SoAh6zXVc.png',
      imgTag: ['❤'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/5428ed15b3_S3z2Gy28re.png',
      imgTag: ['🎈'],
    },
  ],
  '😢': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/114d105259_MCfXW8iV7X.png',
      imgTag: ['😩'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/bf40c20046_fp4Heqmuc4.gif',
      imgTag: ['😞'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/4b3e274ef7_irHjYCl9lz.png',
      imgTag: ['😞'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/d29775243f_9RFVEOkeTN.gif',
      imgTag: ['😞'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/d0803adc80_OWGU3dyK0V.png',
      imgTag: ['🕴'],
    },
  ],
  '😪': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/6faa63f39f_CcXHqygeoX.png',
      imgTag: ['😴'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/76984b831f_rjwmJUjPGy.gif',
      imgTag: ['🛏'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/9aec1720b7_Sms6FceDZr.png',
      imgTag: ['🥴'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/6672f60bc1_zG00AG0yGk.png',
      imgTag: ['😩'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/9f46be5b3d_Cne2a04i0l.png',
      imgTag: ['😑', '🐱'],
    },
  ],
  '😲': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/9decb5140a_aHvQlT5ZBL.gif',
      imgTag: ['❓'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/158f87dc60_8V2cI9wZMI.gif',
      imgTag: ['😅'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/0d349f72fd_uAF2dcY6OK.png',
      imgTag: ['❓', '🐱'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/040ec64268_FSgJQDbJ2B.gif',
      imgTag: ['😱'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/44b7d25ccd_H3J0Z5mVOb.gif',
      imgTag: ['🤩'],
    },
  ],
  '🤗': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/eebff76a87_agdeNrEa43.gif',
      imgTag: ['😊'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/2d44a3aa3f_EkfXRllpRB.png',
      imgTag: ['😞'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/eef1cf0193_YB0FQdSGis.gif',
      imgTag: ['🐣', '👋', '😊'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/d8938b2d40_bDiWhxURPR.png',
      imgTag: ['☺', '🐱'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/0e0afd1bdb_Urm0iibDwI.png',
      imgTag: ['🦸'],
    },
  ],
  '😉': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/67a1f62863_wSHXWjMNbe.gif',
      imgTag: ['🙌'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/ae7b0a53f6_VQIiproEIV.gif',
      imgTag: ['🤩'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/fa3881f2fb_DG0xbRxonx.png',
      imgTag: ['🧎'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/23ab0f595b_zGxb40uGtv.png',
      imgTag: ['👍', '🐰'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/f4eb031521_30Z7z7VvP6.png',
      imgTag: ['👍', '🐰'],
    },
  ],
  '😀': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/cec861b783_Hgau15lcd1.gif',
      imgTag: ['🤣'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/eecbce3f50_SajUBHMEHe.gif',
      imgTag: ['👍'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/13f6ccd897_OSkBuIJepB.gif',
      imgTag: ['😌'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/e66353d656_0U7MSHhRAF.png',
      imgTag: ['❓'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/f3b07fe344_611RNxEIRW.gif',
      imgTag: ['🤣'],
    },
  ],
  '😒': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/dd0abe0aea_KU5HYA3mAy.gif',
      imgTag: ['😞'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/e1f9b9095a_oJybfZeJGe.gif',
      imgTag: ['😰'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/86bef43e38_yQprcl1sB9.png',
      imgTag: ['😆'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/9fbf2d3e27_mrfARzVscq.gif',
      imgTag: ['💔', '😢'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/4171fb25ca_ygGKGM7fTh.png',
      imgTag: ['❌'],
    },
  ],
  '😏': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/df3d8ea946_R7G37WIFhu.png',
      imgTag: ['😜', '🐶'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/5b5ed02b2e_g1HBR11tdj.gif',
      imgTag: ['😀'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/72f73e8c71_JFDK72Gei3.png',
      imgTag: ['🙃'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/82e4f10807_4ATbCtG2TH.png',
      imgTag: ['🤣'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/51974ec2f4_HWPsaTvMSx.png',
      imgTag: ['😤'],
    },
  ],
  '🙃': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/48a7d6bd53_MeHhQASUH5.png',
      imgTag: ['❌'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/5acd37c356_A0FgQux97p.gif',
      imgTag: ['😊', '😀'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/07c5c83174_ESDwGBwII2.png',
      imgTag: ['😒'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/f711d37ed6_UHCT73SFp7.png',
      imgTag: ['😒'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/724c5a2bfc_D0HO48kbGP.png',
      imgTag: ['😏'],
    },
  ],
  '🤤': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/50f978de7d_l2bObV1nbG.png',
      imgTag: ['😋'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/784750f5eb_76w7aV9trG.png',
      imgTag: ['🥘'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/95d9918028_ftVQ7WOwzK.png',
      imgTag: ['🍽'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/e0f969dd00_PrCnCpr8Eg.png',
      imgTag: ['🥤'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/9530224e8f_mDqD1KlF6n.gif',
      imgTag: ['🍔', '🥘', '🍟'],
    },
  ],
  '😴': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/c51f98f98a_EJUxxSuP0c.gif',
      imgTag: ['😩'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/196ec060bf_ENpzI4q6zX.gif',
      imgTag: ['😩'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/329442c2cc_nooeLcgTQV.png',
      imgTag: ['📱'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/51d337d358_oxvmWDHv8X.gif',
      imgTag: ['😪'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/5b69378a18_UTLPPxDMiN.png',
      imgTag: ['💆'],
    },
  ],
  '😅': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/64243c5003_Alm6Yx5uQB.png',
      imgTag: ['😞'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/80f7c99e7a_QuynIV9OLE.png',
      imgTag: ['🙇'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/46cf2b8204_ufdSGqWG4N.png',
      imgTag: ['❓'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/6b6a448c92_O8wDG3yQnM.gif',
      imgTag: ['😲'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/a42551d0ab_5l9QqNXOUY.png',
      imgTag: ['🌧', '☂'],
    },
  ],
  '🤣': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/224459689b_PZATtIxyes.png',
      imgTag: ['😆'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/5c8c812305_k0vp9LxJG3.png',
      imgTag: ['😜'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/8b15dcd58d_1NzJ02d4hC.gif',
      imgTag: ['💃'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/869764d77c_wFpqbn3tyR.png',
      imgTag: ['🙃', '😏'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/ee1861b137_xTAvDydp1O.png',
      imgTag: ['😆', '🎵'],
    },
  ],
  '😑': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/02f67444f2_c5n63xUPQ7.gif',
      imgTag: ['😐', '🐱'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/87c983ec99_87GcZPZ7d4.gif',
      imgTag: ['😴'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/bae536fe2c_rkU08zJHRL.png',
      imgTag: ['💆'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/fd8f547526_WCNZWVVhvC.png',
      imgTag: ['😴'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/8cb713e52d_GxkEr3EQky.png',
      imgTag: ['😞'],
    },
  ],
  '🤔': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/6faa63f39f_CcXHqygeoX.png',
      imgTag: ['😴'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/dc20007d5c_Fge2N2Nry5.png',
      imgTag: ['👀'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/6303172e2f_mqQ7iPmIkY.png',
      imgTag: ['❓'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/7f29ffb4ca_83lZy9cviW.png',
      imgTag: ['❓'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/3102cc8514_7EhMDYMwuh.png',
      imgTag: ['❓'],
    },
  ],
  '😜': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/f905851ef1_xNgPSr5GNX.gif',
      imgTag: ['😆'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/6a3395192a_EP1GDCMTU7.png',
      imgTag: ['😆'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/e88f8bf922_r5DGgocd6O.gif',
      imgTag: ['😆'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/f3b07fe344_611RNxEIRW.gif',
      imgTag: ['🤣'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/269fe9716e_896rQvwLE2.gif',
      imgTag: ['😉'],
    },
  ],
  '😵': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/95ac95fc1f_dTn901SGJK.gif',
      imgTag: ['👋'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/46b33d0d75_nIUXvf0sAB.gif',
      imgTag: ['👊'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/eb19c48a9b_B0F58tXZyx.png',
      imgTag: ['😩'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/da8168b75e_4r7GqWOmT9.png',
      imgTag: ['😱'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/652557d69c_UKsDg7GbO3.png',
      imgTag: ['🤒'],
    },
  ],
  '🤨': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/2449fa7348_lOrz3ebRLi.png',
      imgTag: ['😜'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/f12871cec5_eZYdNroNcx.png',
      imgTag: ['❓'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/749c43c032_P3MJM11Ku5.png',
      imgTag: ['😒'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/d72f2cd29a_RYa54AskNE.png',
      imgTag: ['😅', '😰'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/97eed4b4d9_yyi8nmOOSI.gif',
      imgTag: ['😐'],
    },
  ],
  '👍': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/d30a3c68f9_6Y1BF6L6AD.png',
      imgTag: ['🤩'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/8092c67b17_hLCc7f4oqo.png',
      imgTag: ['😊'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/f6375f9a28_MyRk5r7Hwm.png',
      imgTag: ['🐶', '🙌'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/92771616dc_hl5UyZiHCo.png',
      imgTag: ['🧞'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/ebf3ce7654_f23JAyrPsE.png',
      imgTag: ['👌'],
    },
  ],
  '😱': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/64b170f648_8X52NYleJQ.gif',
      imgTag: ['😡'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/d384a33a92_ZImAtzIKr9.gif',
      imgTag: ['😲'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/352579734a_XHhGWg5tgB.png',
      imgTag: ['😢'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/c54108ae50_4QO74nQ1qy.gif',
      imgTag: ['🏃', '💨'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/bbee719312_D2VkE2VTAv.png',
      imgTag: ['🐰', '🏃'],
    },
  ],
  '😰': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/f1fcfd55d6_bwuWVUXSGh.gif',
      imgTag: ['😢'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/3e5d0310f5_f2WDhrPtxm.png',
      imgTag: ['😅'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/fcbcf3b48d_e31ze1LnV8.gif',
      imgTag: ['😐'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/52fab924b9_0VeQ6sedTZ.gif',
      imgTag: ['😱'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/58bdb7309b_GMW0lr0UgF.png',
      imgTag: ['💸'],
    },
  ],
  '🥴': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/29d24cf273_RHSLNzxIWe.gif',
      imgTag: ['😩'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/7da609fc79_eN2qPX6UEu.png',
      imgTag: ['🍺'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/bd822b917d_V1RdGTVu6j.png',
      imgTag: ['☠'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/efc0341a69_cmOpLbtshO.png',
      imgTag: ['🎵'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/fd0975aad1_75DlN34Ts5.png',
      imgTag: ['🍺'],
    },
  ],
  '😍': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/02162bd6fb_dzCpsy0Xmg.gif',
      imgTag: ['💃'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/1f403fb943_qGFQWx6IF9.gif',
      imgTag: ['🎁'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/831fcbed77_n2kaSRyE5M.png',
      imgTag: ['🙌'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/f4cac1669e_kFkTaKhiEt.png',
      imgTag: ['🤩'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/51667c0d1a_UH0FF13TvY.png',
      imgTag: ['🤗'],
    },
  ],
  '🥺': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/7791c90c01_kYMFdbkZwp.gif',
      imgTag: ['🐰'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/0c3e460301_WKCNumGAQc.png',
      imgTag: ['🌅'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/af8878f21c_CCs81pW4Ym.png',
      imgTag: ['❓'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/ff3683bac7_a3u3j2CTpN.png',
      imgTag: ['💵', '🐶'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/9735fb4a47_152DH7XLAm.gif',
      imgTag: ['🙌'],
    },
  ],
  '😋': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/a95a775e23_3yHZblMJiz.gif',
      imgTag: ['🍽', '🐅'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/fd35c04a69_nsRt5sCBhZ.png',
      imgTag: ['🍽'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/fa1c6a5210_62WODYYgkr.png',
      imgTag: ['🥤', '🍔'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/61f80c9746_gmLrqhlMEM.gif',
      imgTag: ['😊'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/46667d8b15_vWW4vB8StP.gif',
      imgTag: ['🍪'],
    },
  ],
  '😎': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/d6748054db_6G8kI0BdCD.gif',
      imgTag: ['👍'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/88f4ec8c90_JeXuIqLhLI.png',
      imgTag: ['✨'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/cf34e071c4_2vD4iTNRqu.png',
      imgTag: ['🏃'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/2906e06fc4_djEk9yEmhC.png',
      imgTag: ['👍'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/4ef68d160f_bBlDxhO35h.png',
      imgTag: ['🤩', '✨'],
    },
  ],
  '😶': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/16ebeef3a8_Bwg0jke9N1.png',
      imgTag: ['🐣', '😐'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/49b9fe08c2_cGG8Cu9MFH.png',
      imgTag: ['🙇'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/6469e0ba9f_UePYNuf7Gv.png',
      imgTag: ['😅'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/877bacfade_1lT8AERboM.gif',
      imgTag: ['🤫'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/f35cc4b236_vDAmx71OOb.png',
      imgTag: ['😴'],
    },
  ],
  '😩': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/6b5115d86f_7yKltC8WuG.gif',
      imgTag: ['😰'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/8101948ce1_NBqmCJWSLd.gif',
      imgTag: ['😪'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/78bacd6923_xp6CTb1yTE.png',
      imgTag: ['😪'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/7d482235f2_ZRAvLNnq2l.gif',
      imgTag: ['😪', '😴'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/91a40c7810_YRQKVRX2Ll.gif',
      imgTag: ['☕'],
    },
  ],
  '☠': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/0744ff6a7e_RZ4Lb6cmjb.gif',
      imgTag: ['😲', '😱'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/afc6d54b67_NlBQ1evtaO.png',
      imgTag: ['🤼'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/6d569443ed_kC4o2WAGSS.png',
      imgTag: ['🌧', '😞'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/5ccf6dd355_7pb0FMdgYu.gif',
      imgTag: ['😤'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/1dfbb89656_r4wVsVxZBp.png',
      imgTag: ['🥵', '😩'],
    },
  ],
  '😌': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/24e174492a_TPmLcJa2g6.gif',
      imgTag: ['☕'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/445164bc3f_ThAgvcQ6hH.png',
      imgTag: ['😢', '🤗'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/22c0181d25_B7TgHCQEFp.png',
      imgTag: ['😑'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/a240d8124b_277NK4RAvL.png',
      imgTag: ['🛀', '🧖'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/fea3155f11_zKyGBA6qYo.png',
      imgTag: ['🌕', '🤗'],
    },
  ],
  '🙄': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/7c9633aed5_FW4Dyzl2n2.png',
      imgTag: ['🤔'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/238158fe67_k7jQC0YnIh.png',
      imgTag: ['😅'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/878ab59d3f_Cqdr3mxdC2.png',
      imgTag: ['❓'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/bf9019b399_Jaiuv6DN8S.png',
      imgTag: ['🤨'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/8fb0148d32_zW14HBd5or.png',
      imgTag: ['😲'],
    },
  ],
  '🤪': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/dadad9f9ac_xZWRtRFA3A.gif',
      imgTag: ['😑'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/1377f0b088_ZrwG4ghrdf.gif',
      imgTag: ['😜'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/08ace83385_HGpuRIov6w.gif',
      imgTag: ['🐱'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/6055f19765_3zXbirAXUS.png',
      imgTag: ['😒'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/0400970944_EznNswiFND.png',
      imgTag: ['💦'],
    },
  ],
  '😣': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/f7ea5a80da_l5M24rdZIU.png',
      imgTag: ['😒', '😡'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/85e04b7e07_XovsrSrvQD.png',
      imgTag: ['🤤'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/8926a052c9_wiA5H3yKnp.png',
      imgTag: ['😩', '👨‍⚕️'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/4dec303e88_fkJ0ZmAKip.png',
      imgTag: ['😢', '😰'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/a2e9195e76_k1K2lABvUF.png',
      imgTag: ['🤯'],
    },
  ],
  '😤': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/b5c06fff00_BvyFuI52xG.gif',
      imgTag: ['😡'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/ce4f2ab00b_oDcC8grCaw.png',
      imgTag: ['😞'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/249ffa6501_v1EEDe5tGQ.png',
      imgTag: ['❌'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/89f4ef33fc_cYaCMVrZzM.png',
      imgTag: ['🤔'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/ebba415f7f_vQv9w5NebG.png',
      imgTag: ['😡'],
    },
  ],
  '🤩': [
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/3e540fea44_wHLp9qUAfR.gif',
      imgTag: ['👍'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/ee327a795c_JGDAxLX1mA.gif',
      imgTag: ['😍', '❤'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/e4032adc05_9uc9r5w2Vc.png',
      imgTag: ['😆'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/a6bbfb3f79_uMRKOmMDgt.png',
      imgTag: ['😍'],
    },
    {
      imgLink:
        'https://img-i.mojitok.com/emoticons/w300/8a800071d7_3iAWW7JbdU.png',
      imgTag: ['🐰', '👏'],
    },
  ],
}
